import React, { useState } from "react";
import { Popover, Input, Button } from "antd";
import { get } from "lodash";
import styled from 'styled-components';
import { SearchOutlined } from "@ant-design/icons";
import { StyledSearchWrapper } from './styled';

const SearchToolEle = styled(Button) <{
  visible: boolean;
}>`
  && {
    display: ${(props) => (props.visible ? "inline-block" : "none")};
  }
`;

const { Search } = Input;

const SearchTool = ({
  currentKey,
  onSearch,
  columnSearchData,
}) => {
  const [visible, setVisible] = useState(false);
  const [searchText, setSearchText] = useState("");

  const handleSearch = (value) => {
    onSearch({ key: currentKey, text: value });
    setVisible(false);
  };

  const handleChange = (e) => {
    if (get(e, "type") === "click" && !get(e, ["currentTarget", "value"])) {
      setSearchText("");
      setVisible(false);
    } else {
      setSearchText(e.target.value);
    }
  };

  const renderSearchContent = () => (
    <StyledSearchWrapper>
      <Search
        defaultValue={searchText}
        allowClear
        onSearch={handleSearch}
        onChange={handleChange}
        autoFocus
        size="small"
        width={100}
        enterButton="Search"
        value={searchText}
      />
    </StyledSearchWrapper>
  );

  const visibleChange = () => {
    if (currentKey !== columnSearchData.key) {
      setSearchText("");
    }
    setVisible(!visible);
  };

  return (
    <Popover
      onOpenChange={visibleChange}
      content={renderSearchContent()}
      placement="bottom"
      trigger="click"
      open={visible}
    >
      <SearchToolEle
        visible={
          visible || (currentKey === columnSearchData.key)
        }
        icon={<SearchOutlined />}
      />
    </Popover>
  );
};

export default SearchTool;
